<div class="pb-6 px-6 pt-4 rounded md:px-8 md:pb-0 md:pt-0  max-w-lg m-auto">
    <div class="flex flex-col gap-6 items-center justify-center">
        <!--submit next-->
        <ng-container *ngIf="sent; else forgottenPasswordForm">
            <div class="text-center ">
                <h1 class="mb-6"><i class="icon icon-checkmark-circle-3 text-success-500"
                        style="font-size: 80px !important;"></i></h1>
                <h2 class="text-xl md:text-xl lg:text-2xl font-bold text-gray-700 mb-2">{{ 'auth.success' | translate }}</h2>
                <p class="text-base  text-gray-500 mb-2">{{ 'auth.email-sent' | translate }}</p>
            </div>
            <msc-button icon="fa-solid fa-arrow-right"
                class="msc-button--primary self-center duration-500 transform hover:scale-105"
                style="width:50% !important;" palette="primary" (click)="navigate()">
                {{ 'words.continue' | translate }}
            </msc-button>
        </ng-container>
        <!--restore-->
        <ng-template #forgottenPasswordForm>
            <div class="block lg:hidden">
                <div
                    class="relative flex items-center justify-center w-20 h-20 rounded-full border-2 border-primary-100  group">
                    <div
                        class="absolute inset-0 rounded-full  group-hover:opacity-100 transition-opacity duration-300">
                    </div>
                    <img src="assets/images/restore-password2.png"
                        class="w-10 h-10 transition-all duration-300 group-hover:scale-110"
                        style="filter: brightness(0.7);">
                </div>
            </div>
            <div class="text-center mb-6">
                <h2 class="text-xl md:text-xl lg:text-2xl font-bold text-gray-700 mb-2">{{ 'auth.forgot-your-password' | translate
                    }}</h2>
                <p class="text-base  text-gray-500">{{ 'auth.enter-your-email-for-password-recovery' |
                    translate }}</p>
            </div>

            <form class="flex flex-col w-full space-y-4" (ngSubmit)="submit()">
                <div class="sslide__input mb-4">
                    <msc-input [label]="'auth.identifier' | translate" id="email" type="text" [(ngModel)]="email"
                        name="email" placeholder="example@email.com" required [hasErrors]="errors.email"></msc-input>
                    <span class="invalid-feedback" role="alert" *ngIf="errors.email">
                        <strong>{{ 'auth.email-format' | translate }}</strong>
                    </span>
                </div>
                <!--btn submit-->
                <msc-button class="w-full msc-button--primary self-center duration-500 transform hover:scale-105"
                    style="width:50% !important;" htmlType="submit" palette="primary" [loading]="loading"
                    [disabled]="errors.email">
                    {{ 'words.send' | translate }}
                </msc-button>

                <!--
                <div class="btn-submit flex flex-row" style="padding-bottom: 0.5rem !important;">
                    <msc-button class="w-1/2 duration-500 transform hover:scale-105" htmlType="back">
                       <p>🡨</p>
                    </msc-button>
                    <msc-button class=" msc-button--primary self-center duration-500 transform hover:scale-105" style="width:50% !important;" htmlType="submit" palette="primary" [loading]="loading"
                        [disabled]="errors.email">
                        {{ 'words.send' | translate }}
                    </msc-button>
                </div> -->
            </form>
        </ng-template>
    </div>
</div>